import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { url } from 'src/app/config/config';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';



@Injectable()
export class ImprimirMultipleService {
    public myurl=url+"informes/";

    @Output() mostrarProductos:EventEmitter<any> = new EventEmitter();
    public ListProductos: Subject<any> = new Subject();

    constructor(private http:HttpClient) {
      
     }
     showProducts(productos){
      console.log("showProductos",productos);
      this.mostrarProductos.emit({productos});
     }
     
     mostrar(productos){
      console.log("showProductos",productos);
      this.ListProductos.next({productos});
     }

    

     getId(id,base){
       
        let headers=new HttpHeaders();
        let body=JSON.stringify([{"id":id}]);
       
        headers.append('Content-Type' , 'application/json');
        return this.http.post(this.myurl+""+base+"Id.php",body,{headers:headers}).pipe(map(res=>{
          
           return res;
         }));
       }
       getAnexo(fecha,base){
        let headers=new HttpHeaders();
        let body=JSON.stringify({"fecha":fecha,"categoria":base});
       
        headers.append('Content-Type' , 'application/json');
        return this.http.post(url+"categoria/fechaAnexoAnterior.php",body,{headers:headers}).pipe(map(res=>{
          
           return res;
         }));
       }
}
